import { render, staticRenderFns } from "./OrderSizeModule.vue?vue&type=template&id=ec9902d2"
import script from "./OrderSizeModule.vue?vue&type=script&lang=js"
export * from "./OrderSizeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports